import React from 'react'
import Slider from "react-slick";
import ClickLinkCard from './ClickLinkCard';

import * as S from './styled'


const CardExame = ({ isMobile, dataCard }) => {

    const settings = {
        dots: false,
        autoplay: false,
        infinite: true,
        autoplaySpeed: 10000,
        speed: 500,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true
    }
    
    return (
        <S.SectionCard data-testid="SectionCard-div">
            <S.ContentCards>
                <S.MainContent>
                    <S.TitleSectionCards data-testid="TitleSectionCard-h2">
                        Serviços para você
                    </S.TitleSectionCards>
                    <S.ContainerCardsExame data-testid="ContainerCardsExame-div">
                        <Slider {...settings}>
                          {dataCard && dataCard.map((x,i) => {
                            return <ClickLinkCard key={i} infoCard={x.node.acf} isMobile />
                          })}
                        </Slider>
                        <>
                          {dataCard && dataCard.map((x,i) => {
                            return <ClickLinkCard key={i} infoCard={x.node.acf}/>
                          })}
                        </>
                    </S.ContainerCardsExame>
                </S.MainContent>
            </S.ContentCards>
        </S.SectionCard>
    )

}

export default CardExame
